<script lang="ts">
  import clsx from 'clsx';
  import { type Responsive } from '@athena-lib/responsive-utils';
  import { objectEntries } from '@athena-lib/object-utils';
  import { getColorContext, lightColors } from '@athena-lib/container-context.svelte';
  import { textColors } from '../../colors';
  import { type TextProps, getTextSizeClasses } from './types';
  const colorContext = getColorContext();
  const {
    id,
    children,
    class: className,
    color,
    size = 'medium',
    element = 'div',
    italic,
    bold,
  }: TextProps = $props();

  const responsiveTextColors = $derived.by(() => {
    const contextBackground = colorContext.value;
    const responsiveTextColorObj: Responsive<string> = {
      lg:
        contextBackground.lg === 'brand'
          ? 'lg:text-st-black'
          : lightColors.includes(contextBackground.lg)
            ? 'lg:text-st-gray-800'
            : 'lg:text-st-white',
      md:
        contextBackground.md === 'brand'
          ? 'md:text-st-black'
          : lightColors.includes(contextBackground.md)
            ? 'md:text-st-gray-800'
            : 'md:text-st-white',
      sm:
        contextBackground.sm === 'brand'
          ? 'text-st-black'
          : lightColors.includes(contextBackground.sm)
            ? 'text-st-gray-800'
            : 'text-st-white',
    };

    return objectEntries(responsiveTextColorObj)
      .map(([_, value]) => value)
      .join(' ');
  });
</script>

<svelte:element
  this={element}
  {id}
  class={clsx(
    !color && responsiveTextColors,
    className,
    color && textColors[color],
    getTextSizeClasses(size),
    italic && 'italic',
    bold && 'font-bold',
  )}
>
  {#if children}
    {@render children()}
  {/if}
</svelte:element>
